export const RoutingEndpoints = {
  home: () => '/',
  dashboard: () => '/organization/:organizationId',
  notFound: () => '/not-found',
};
